import _BaseAPIService from '../_BaseAPIService';

const apiService = _BaseAPIService.instance;

const slug = 'api';
const SalesServices = {
  // Define your API functions here
  getList: async ({ startDate, endDate }) => {
    const response = await apiService.get(
      `${slug}/dashboard/salesreportdata?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  },
 
};

export default SalesServices;
